const state = {
  sm_orders: [],
  sm_order_types: [],
};

export default state;
